import React from 'react';
import styled, { css } from 'styled-components';
import { GLOBALS } from '../../utils/globals';
import ArrowYellow from '../../svg/arrow-yellow.svg';
import ArrowBlue from '../../svg/arrow-blue.svg';
import { useTranslation } from 'react-i18next';

interface ScrollToProps {
  className?: string;
  target: string;
}

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const StyledArrowStyles = css`
  margin-bottom: 15px;
  width: var(--scrollto-width);
  height: auto;
`;

const StyledArrowYellow = styled(ArrowYellow)`
  ${StyledArrowStyles}
`;

const StyledArrowBlue = styled(ArrowBlue)`
  ${StyledArrowStyles}
`;

const ScrollTo = ({ className, target }: ScrollToProps) => {
  const { t, i18n } = useTranslation();
  return (
    <StyledContainer className={className}>
      <a href={target}>
        {GLOBALS.theme === 'yellow' ? <StyledArrowYellow /> : <StyledArrowBlue />}
      </a>
    </StyledContainer>
  );
};
export default ScrollTo;
